jQuery(function($){

  $('.btn-msb-toggle').on('click', function(event){
    event.preventDefault();
    $('body').toggleClass('msb-x');
  });

  // $('.mhp-nav-responsive .mhp-mobile-nav li a').on('click', function(){
  //   $('body').addClass('msb-x');
  // });

  $('.btn-try-crossfit').on('click', function(event){
    event.preventDefault();
    $('body').addClass('mobile-form-open');
  });

  $('.btn-close-form-crossfit').on('click', function(event){
    event.preventDefault();
    $('body').removeClass('mobile-form-open');
  });

});



// WEBPACK FOOTER //
// ./scripts/autoload/_responsive-nav.js